export const ERROR_CODES: Record<string, Record<string, string>> = {
	FE04: {
		code: 'FE04',
		description: 'Erreur de connexion à la base de données ou au serveur de jeton.'
	},
	FE07: {
		code: 'FE07',
		description: 'Echec répété d\'authentification par mot de passe. L\'authentification par mot de passe est bloquée pour une courte durée.'
	},
	FE08: {
		code: 'FE08',
		description: 'Le format des données saisies est incorrect.'
	},
	FE09: {
		code: 'FE09',
		description: 'Le triplet renseigné (Nom, Prénom, SIRET) correspond à un compte en cours de suppression.'
	},
	FE15: {
		code: 'FE15',
		description: 'Le triplet renseigné (Nom, Prénom, SIRET) ne correspond à aucun utilisateur connu du système ou le mot de passe est incorrect.'
	},
	FE16: {
		code: 'FE16',
		description: 'L\'inscription de l\'utilisateur est encore en cours.'
	},
	FE18: {
		code: 'FE18',
		description: 'Le jeton de l\'utilisateur a expiré après que la page contenant le widget ait été chargée.'
	},
	FE19: {
		code: 'FE19',
		description: 'L\'utilisateur n\'est pas habilité au service renseigné en paramètre.'
	},
	FE20: {
		code: 'FE20',
		description: 'Le délai d\'accès au service renseigné en paramètre n\'est pas révolu pour l\'utilisateur.'
	},
	FE21: {
		code: 'FE21',
		description: 'L\'acteur ne possède pas au moins 1 rôle parmi ceux paramétrés.'
	},
	FE22: {
		code: 'FE22',
		description: 'L\'acteur n\'est pas rattaché à une entreprise dont le type d\'inscription (TD ou DDNONTD) correspond à la valeur du paramètre.'
	},
	FE23: {
		code: 'FE23',
		description: 'L\'acteur n\'est pas rattaché à une entreprise ayant un nombre d\'établissements correspondant à la valeur du paramètre (MONO ou MULTI).'
	}
};
